import { render, staticRenderFns } from "./RentalRatesConfig.vue?vue&type=template&id=18a0701c&scoped=true&"
import script from "./RentalRatesConfig.vue?vue&type=script&lang=js&"
export * from "./RentalRatesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a0701c",
  null
  
)

export default component.exports